import { render, staticRenderFns } from "./IikoCardQrScheduleSettings.vue?vue&type=template&id=0a61f968"
import script from "./IikoCardQrScheduleSettings.vue?vue&type=script&lang=js"
export * from "./IikoCardQrScheduleSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports